// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Anti-Phishing flow — fully scoped */
.apc-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.apc-page *,
.apc-page *::before,
.apc-page *::after {
  box-sizing: border-box;
}

.apc-page__crumbs {
  margin-bottom: 18px;
}

.apc-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.apc-page__crumbItem--active {
  color: #e9e9e9;
  font-weight: 500;
}

body.light_theme .apc-page__crumbItem--active {
  color: #101828;
}

.apc-page__crumbSep {
  color: #8e939c;
}

.apc-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.apc-page__crumbLink:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.apc-page__title {
  margin: 0 0 22px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #dfdfdf;
}

body.light_theme .apc-page__title {
  color: #101828;
}

.apc-page__subtitle {
  margin: -14px 0 22px;
  font-size: 14px;
  color: #8e939c;
  font-weight: 500;
}

.apc-card {
  width: 600px;
  max-width: 100%;
  margin: 60px auto;
}

.apc-card--reset {
  width: 600px;
  margin-top: 90px;
}

.apc-field {
  margin-bottom: 16px;
}

.apc-label {
  display: block;
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 500;
  color: #e4e4e4;
}

body.light_theme .apc-label {
  color: #101828;
}

.apc-inputRow {
  position: relative;
}

.apc-input {
  width: 100%;
  height: 48px;
  border-radius: 6px;
  border: 1px solid #eef2f61f;
  background: #f3f4f60f;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 500;
  color: #fff !important;
  outline: none;
}

body:not(.light_theme) .apc-page .apc-input,
body:not(.light_theme) .apc-page input.apc-input {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
}

body.light_theme .apc-page .apc-input,
body.light_theme .apc-input {
  border: 1px solid #eef2f6;
  background: #f3f4f6;
  color: #101828 !important;
  -webkit-text-fill-color: #101828 !important;
}

.apc-input:focus {
  color: #fff !important;
}

body:not(.light_theme) .apc-page .apc-input:focus {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
}

body.light_theme .apc-input:focus {
  color: #101828 !important;
}

.apc-input--row {
  padding-right: 84px;
}

.apc-input::placeholder,
body:not(.light_theme) .apc-page .apc-input::placeholder {
  color: #6b7280 !important;
  -webkit-text-fill-color: #6b7280 !important;
  font-weight: 600;
}

body.light_theme .apc-input::placeholder,
body.light_theme .apc-page .apc-input::placeholder {
  color: #9ca3af !important;
  -webkit-text-fill-color: #9ca3af !important;
}

.apc-send {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: #AC8A50;
  cursor: pointer;
}

.apc-hint {
  margin-top: 10px;
  font-size: 13px;
  color: #84888C;
  font-weight: 400;
}

.apc-note {
  margin-top: 10px;
  font-size: 12px;
  color: #8e939c;
  font-weight: 500;
  line-height: 1.45;
}

.apc-primary {
  width: 100%;
  height: 50px;
  border-radius: 999px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: not-allowed;
  margin-top: 26px;
}

.apc-primary.is-enabled {
  cursor: pointer;
}

.apc-link {
  margin: 8px 0 0;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: #AC8A50;
  /* text-decoration: underline; */
  text-underline-offset: 3px;
  cursor: pointer;
}

/* Reset choice */
.apc-choice {
  width: 100%;
  border: none;
  background: #F5F6F7;
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  cursor: pointer;
}

.apc-choice__left {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.apc-choice__icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #111827;
}

.apc-choice__text {
  display: grid;
}

.apc-choice__title {
  font-size: 14px;
  font-weight: 500;
  color: #101828;
  text-align: left;
}

.apc-choice__sub {
  font-size: 12px;
  font-weight: 600;
  color: #84888C;
  margin-top: 1px;
}

.apc-choice__radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  background: #fff;
}

.apc-choice.is-selected {
  border-color: rgba(172, 138, 80, 0.35);
}

.apc-choice.is-selected .apc-choice__radio {
  border-color: #84888C;
  box-shadow: inset 0 0 0 2px #84888C;
}

/* Opens passkey-style method picker (Anti-Phishing) */
.apc-choice--trigger {
  width: 100%;
  min-height: 56px;
  border: 1px solid #eef2f6;
  border-radius: 8px;
  text-align: left;
}

.apc-choice--trigger:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.apc-choice__chev {
  font-size: 22px;
  font-weight: 400;
  color: #9ca3af;
  line-height: 1;
  flex-shrink: 0;
}

/* Selected row in method picker modal (passkey-modal list) */
.passkey-modal__item--active {
  border-color: rgba(172, 138, 80, 0.45);
  background: rgba(172, 138, 80, 0.08);
}

.passkey-modal__item--active:hover {
  background: rgba(172, 138, 80, 0.1);
}

@media (max-width: 767px) {
  .apc-page {
    padding: 30px 16px 20px;
  }

  .apc-page__title {
    font-size: 22px;
  }

  .apc-primary {
    height: 44px;
  }

  .apc-page__crumbList {
    font-size: 13px;
  }

  .apc-card {
    margin: 30px auto;
  }

  .apc-label {
    font-size: 13px;
  }

  .apc-primary {
    font-size: 14px;
    margin-top: 12px;
  }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/antiPhishing.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;;AAGF","sourcesContent":["/* Anti-Phishing flow — fully scoped */\n.apc-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.apc-page *,\n.apc-page *::before,\n.apc-page *::after {\n  box-sizing: border-box;\n}\n\n.apc-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.apc-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.apc-page__crumbItem--active {\n  color: #e9e9e9;\n  font-weight: 500;\n}\n\nbody.light_theme .apc-page__crumbItem--active {\n  color: #101828;\n}\n\n.apc-page__crumbSep {\n  color: #8e939c;\n}\n\n.apc-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.apc-page__crumbLink:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.apc-page__title {\n  margin: 0 0 22px;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #dfdfdf;\n}\n\nbody.light_theme .apc-page__title {\n  color: #101828;\n}\n\n.apc-page__subtitle {\n  margin: -14px 0 22px;\n  font-size: 14px;\n  color: #8e939c;\n  font-weight: 500;\n}\n\n.apc-card {\n  width: 600px;\n  max-width: 100%;\n  margin: 60px auto;\n}\n\n.apc-card--reset {\n  width: 600px;\n  margin-top: 90px;\n}\n\n.apc-field {\n  margin-bottom: 16px;\n}\n\n.apc-label {\n  display: block;\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #e4e4e4;\n}\n\nbody.light_theme .apc-label {\n  color: #101828;\n}\n\n.apc-inputRow {\n  position: relative;\n}\n\n.apc-input {\n  width: 100%;\n  height: 48px;\n  border-radius: 6px;\n  border: 1px solid #eef2f61f;\n  background: #f3f4f60f;\n  padding: 0 14px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff !important;\n  outline: none;\n}\n\nbody:not(.light_theme) .apc-page .apc-input,\nbody:not(.light_theme) .apc-page input.apc-input {\n  color: #ffffff !important;\n  -webkit-text-fill-color: #ffffff !important;\n}\n\nbody.light_theme .apc-page .apc-input,\nbody.light_theme .apc-input {\n  border: 1px solid #eef2f6;\n  background: #f3f4f6;\n  color: #101828 !important;\n  -webkit-text-fill-color: #101828 !important;\n}\n\n.apc-input:focus {\n  color: #fff !important;\n}\n\nbody:not(.light_theme) .apc-page .apc-input:focus {\n  color: #ffffff !important;\n  -webkit-text-fill-color: #ffffff !important;\n}\n\nbody.light_theme .apc-input:focus {\n  color: #101828 !important;\n}\n\n.apc-input--row {\n  padding-right: 84px;\n}\n\n.apc-input::placeholder,\nbody:not(.light_theme) .apc-page .apc-input::placeholder {\n  color: #6b7280 !important;\n  -webkit-text-fill-color: #6b7280 !important;\n  font-weight: 600;\n}\n\nbody.light_theme .apc-input::placeholder,\nbody.light_theme .apc-page .apc-input::placeholder {\n  color: #9ca3af !important;\n  -webkit-text-fill-color: #9ca3af !important;\n}\n\n.apc-send {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #AC8A50;\n  cursor: pointer;\n}\n\n.apc-hint {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #84888C;\n  font-weight: 400;\n}\n\n.apc-note {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #8e939c;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.apc-primary {\n  width: 100%;\n  height: 50px;\n  border-radius: 999px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: not-allowed;\n  margin-top: 26px;\n}\n\n.apc-primary.is-enabled {\n  cursor: pointer;\n}\n\n.apc-link {\n  margin: 8px 0 0;\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #AC8A50;\n  /* text-decoration: underline; */\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\n/* Reset choice */\n.apc-choice {\n  width: 100%;\n  border: none;\n  background: #F5F6F7;\n  border-radius: 8px;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  cursor: pointer;\n}\n\n.apc-choice__left {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.apc-choice__icon {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #111827;\n}\n\n.apc-choice__text {\n  display: grid;\n}\n\n.apc-choice__title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #101828;\n  text-align: left;\n}\n\n.apc-choice__sub {\n  font-size: 12px;\n  font-weight: 600;\n  color: #84888C;\n  margin-top: 1px;\n}\n\n.apc-choice__radio {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #d1d5db;\n  background: #fff;\n}\n\n.apc-choice.is-selected {\n  border-color: rgba(172, 138, 80, 0.35);\n}\n\n.apc-choice.is-selected .apc-choice__radio {\n  border-color: #84888C;\n  box-shadow: inset 0 0 0 2px #84888C;\n}\n\n/* Opens passkey-style method picker (Anti-Phishing) */\n.apc-choice--trigger {\n  width: 100%;\n  min-height: 56px;\n  border: 1px solid #eef2f6;\n  border-radius: 8px;\n  text-align: left;\n}\n\n.apc-choice--trigger:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.apc-choice__chev {\n  font-size: 22px;\n  font-weight: 400;\n  color: #9ca3af;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n/* Selected row in method picker modal (passkey-modal list) */\n.passkey-modal__item--active {\n  border-color: rgba(172, 138, 80, 0.45);\n  background: rgba(172, 138, 80, 0.08);\n}\n\n.passkey-modal__item--active:hover {\n  background: rgba(172, 138, 80, 0.1);\n}\n\n@media (max-width: 767px) {\n  .apc-page {\n    padding: 30px 16px 20px;\n  }\n\n  .apc-page__title {\n    font-size: 22px;\n  }\n\n  .apc-primary {\n    height: 44px;\n  }\n\n  .apc-page__crumbList {\n    font-size: 13px;\n  }\n\n  .apc-card {\n    margin: 30px auto;\n  }\n\n  .apc-label {\n    font-size: 13px;\n  }\n\n  .apc-primary {\n    font-size: 14px;\n    margin-top: 12px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
